export default [
  {
    path: "/configurations/procurement-rules",
    name: "procurement-rules",
    meta: { title: "Procurement Rules", authRequired: true, privileges: ['VIEW_PROCUREMENT_RULES'] },
    component: () => import("../views/configurations/procurement-rules.vue"),
  },
  // Bidding Methods Routes
  {
    path: "/configurations/bidding-methods",
    name: "bidding-methods",
    meta: {
      title: "Bidding Methods",
      authRequired: true,
      privileges: [
        'VIEW_BIDDING_METHODS',
      ]},
    component: () => import("../views/configurations/bidding-methods.vue"),
  },
  {
    path: "/configurations/bidding-method-management",
    name: "bidding-method-management",
    meta: {
      title: "Bid Submission",
      authRequired: true,
      privileges: [
        'VIEW_BIDDING_METHODS',
      ]},
    component: () => import("../views/configurations/bidding-method-management.vue"),
  },
  {
    path: "/configurations/bidding-method/new",
    name: "new-bidding-method",
    meta: {
      title: "New Bidding Method",
      authRequired: true,
      privileges: [
        'MODIFY_BIDDING_METHODS',
      ]},
    component: () => import("../views/configurations/new-bidding-method.vue"),
  },
  {
    path: "/configurations/bidding-method/archive",
    name: "archive-bidding-method",
    meta: {
      title: "Archive Bidding Method",
      authRequired: true,
      privileges: [
        'MODIFY_BIDDING_METHODS',
      ]},
    component: () => import("../views/configurations/archive-bidding-method.vue"),
  },
  {
    path: "/configurations/bidding-method/import",
    name: "bidding-method-import",
    meta: {
      title: "Bidding Method Import",
      authRequired: true,
      privileges: [
        'MODIFY_BIDDING_METHODS',
      ]},
    component: () => import("../views/configurations/bidding-method-bulk-upload.vue"),
  },

  // Evaluation Methods Routes
  {
    path: "/configurations/evaluation-method-management",
    name: "evaluation-method-management",
    meta: {
      title: "Evaluation Methods",
      moduleKey: "evaluationMethod",
      authRequired: true,
      privileges: [
        'VIEW_EVALUATION_METHODS',
      ] },
    component: () => import("../views/configurations/lightweight-configuration-management.vue"),
  },
  {
    path: "/configurations/evaluation-methods",
    name: "evaluation-methods",
    meta: {
      title: "Evaluation Methods",
      authRequired: true,
      privileges: [
        'VIEW_EVALUATION_METHODS',
      ] },
    component: () => import("../views/configurations/evaluation-methods.vue"),
  },
  {
    path: "/configurations/evaluation-method/new",
    name: "new-evaluation-method",
    meta: {
      title: "New Evaluation Method",
      authRequired: true,
      privileges: [
        'MODIFY_EVALUATION_METHODS',
      ],
      moduleKey: "evaluationMethod"},
    component: () => import("../views/configurations/lightweight-configuration-form.vue"),
  },
  {
    path: "/configurations/evaluation-method/import",
    name: "evaluation-method-import",
    meta: {
      title: "Evaluation Method Import",
      authRequired: true,
      privileges: [
        'MODIFY_EVALUATION_METHODS',
      ]},
    component: () => import("../views/configurations/evaluation-method-bulk-upload.vue"),
  },

  // Exchange Rates Routes
  {
    path: "/configurations/exchange-rate-management",
    name: "exchange-rate-management",
    meta: {
      title: "Exchange Rates",
      moduleKey: "exchangeRate",
      authRequired: true,
      privileges: [
        'VIEW_EXCHANGE_RATES',
      ]},
    component: () => import("../views/configurations/lightweight-configuration-management.vue"),
  },
  {
    path: "/configurations/exchange-rates",
    name: "exchange-rates",
    meta: {
      title: "Exchange Rates",
      authRequired: true,
      privileges: [
        'VIEW_EXCHANGE_RATES',
      ]},
    component: () => import("../views/configurations/exchange-rates.vue"),
  },
  {
    path: "/configurations/exchange-rate/new",
    name: "new-exchange-rate",
    meta: {
      title: "New Exchange Rate",
      authRequired: true,
      privileges: [
        'MODIFY_EXCHANGE_RATES',
      ],
      moduleKey: "exchangeRate"},
    component: () => import("../views/configurations/lightweight-configuration-form.vue"),
  },
  {
    path: "/configurations/exchange-rate/import",
    name: "exchange-rate-import",
    meta: {
      title: "Exchange Rate Import",
      authRequired: true,
      privileges: [
        'MODIFY_EXCHANGE_RATES',
      ]},
    component: () => import("../views/configurations/exchange-rate-bulk-upload.vue"),
  },

  // Procurement Types Routes
  {
    path: "/configurations/procurement-method-management",
    name: "procurement-method-management",
    meta: {
      title: "Procurement Methods",
      authRequired: true,
      privileges: [
        'VIEW_PROCUREMENT_METHODS',
      ]},
    component: () => import("../views/configurations/procurement-method-management.vue"),
  },
  {
    path: "/configurations/procurement-methods",
    name: "procurement-methods",
    meta: {
      title: "Procurement Methods",
      authRequired: true,
      privileges: [
        'VIEW_PROCUREMENT_METHODS',
      ]},
    component: () => import("../views/configurations/procurement-types.vue"),
  },
  {
    path: "/configurations/procurement-method/new/:id?",
    name: "new-procurement-method",
    meta: {
      title: "New Procurement Method",
      authRequired: true,
      privileges: [
        'MODIFY_PROCUREMENT_METHODS',
      ]},
    component: () => import("../views/configurations/new-procurement-type.vue"),
  },
  {
    path: "/configurations/procurement-method/view/:id",
    name: "view-procurement-method",
    meta: {
      title: "View Procurement Method",
      authRequired: true,
      privileges: [
        'VIEW_PROCUREMENT_METHODS',
      ]},
    component: () => import("../views/configurations/view-procurement-method.vue"),
  },

  // System Modules Routes
  {
    path: "/configurations/system-module-management",
    name: "system-module-management",
    meta: {
      title: "Module Management",
      moduleKey: "systemModule",
      authRequired: true,
      privileges: [
        'VIEW_SYSTEM_MODULES',
      ]},
    component: () => import("../views/configurations/lightweight-configuration-management.vue"),
  },
  {
    path: "/configurations/system-modules",
    name: "system-modules",
    meta: {
      title: "System Modules",
      authRequired: true,
      privileges: [
        'VIEW_SYSTEM_MODULES',
      ]},
    component: () => import("../views/configurations/system-modules.vue"),
  },
  {
    path: "/configurations/system-module/new",
    name: "new-system-module",
    meta: {
      title: "New System Module",
      authRequired: true,
      privileges: [
        'MODIFY_SYSTEM_MODULES',
      ],
      moduleKey: "systemModule"},
    component: () => import("../views/configurations/lightweight-configuration-form.vue"),
  },
  {
    path: "/configurations/system-module/import",
    name: "system-module-import",
    meta: {
      title: "System Module Import",
      authRequired: true,
      privileges: [
        'MODIFY_SYSTEM_MODULES',
      ]},
    component: () => import("../views/configurations/system-module-bulk-upload.vue"),
  },

  // System Settings Routes
  {
    path: "/configurations/system-setting-management",
    name: "system-setting-management",
    meta: {
      title: "System Settings",
      moduleKey: "systemSetting",
      authRequired: true,
      privileges: [
        'MODIFY_SYSTEM_SETTINGS',
      ]},
    component: () => import("../views/configurations/lightweight-configuration-management.vue"),
  },
  {
    path: "/configurations/system-settings",
    name: "system-settings",
    meta: {
      title: "System Settings",
      authRequired: true,
      privileges: [
        'MODIFY_SYSTEM_SETTINGS',
      ]},
    component: () => import("../views/configurations/system-settings.vue"),
  },
  {
    path: "/configurations/system-setting/new",
    name: "new-system-setting",
    meta: {
      title: "New System Setting",
      authRequired: true,
      privileges: [
        'MODIFY_SYSTEM_SETTINGS',
      ],
      moduleKey: "systemSetting"},
    component: () => import("../views/configurations/lightweight-configuration-form.vue"),
  },

  // UNSPSC Segments Routes
  {
    path: "/configurations/unspsc-segments",
    name: "commodity-segments",
    meta: {
      title: "Commodity Segments",
      authRequired: true,
      privileges: [
        'VIEW_UNSPSC_SEGMENTS',
      ]},
    component: () => import("../views/configurations/unspsc-segments.vue"),
  },
  {
    path: "/configurations/unspsc-segment-management",
    name: "unspsc-segment-management",
    meta: {
      title: "UNSPSC Segments",
      authRequired: true,
      privileges: [
        'VIEW_UNSPSC_SEGMENTS',
      ]},
    component: () => import("../views/configurations/unspsc-segment-management.vue"),
  },
  {
    path: "/configurations/unspsc-segment/new",
    name: "new-commodity-segment",
    meta: {
      title: "New Commodity Segment",
      authRequired: true,
      privileges: [
        'MODIFY_UNSPSC_SEGMENT',
      ]},
    component: () => import("../views/configurations/new-unspsc-segment.vue"),
  },
  {
    path: "/configurations/unspsc-segment/archive",
    name: "archive-unspsc-segment",
    meta: {
      title: "Archive UNSPSC Segment",
      authRequired: true,
      privileges: [
        'MODIFY_UNSPSC_SEGMENT',
      ]},
    component: () => import("../views/configurations/archive-unspsc-segment.vue"),
  },
  {
    path: "/configurations/unspsc-segment/import",
    name: "commodity-segment-import",
    meta: {
      title: "Commodity Segment Import",
      authRequired: true,
      privileges: [
        'MODIFY_UNSPSC_SEGMENT',
      ]},
    component: () => import("../views/configurations/unspsc-segments-bulk-upload.vue"),
  },

  // UNSPSC Families Routes
  {
    path: "/configurations/unspsc-families",
    name: "commodity-families",
    meta: {
      title: "Commodity Families",
      authRequired: true,
      privileges: [
        'VIEW_UNSPSC_FAMILY',
      ]},
    component: () => import("../views/configurations/unspsc-families.vue"),
  },
  {
    path: "/configurations/unspsc-family-management",
    name: "unspsc-family-management",
    meta: {
      title: "UNSPSC Families",
      authRequired: true,
      privileges: [
        'VIEW_UNSPSC_FAMILY',
      ]},
    component: () => import("../views/configurations/unspsc-family-management.vue"),
  },
  {
    path: "/configurations/unspsc-family/new",
    name: "new-commodity-family",
    meta: {
      title: "New Commodity Family",
      authRequired: true,
      privileges: [
        'MODIFY_UNSPSC_FAMILY',
      ] },
    component: () => import("../views/configurations/new-unspsc-family.vue"),
  },
  {
    path: "/configurations/unspsc-family/archive",
    name: "archive-unspsc-family",
    meta: {
      title: "Archive UNSPSC Family",
      authRequired: true,
      privileges: [
        'MODIFY_UNSPSC_FAMILY',
      ]},
    component: () => import("../views/configurations/archive-unspsc-family.vue"),
  },
  {
    path: "/configurations/unspsc-family/import",
    name: "commodity-family-import",
    meta: {
      title: "Commodity Family Import",
      authRequired: true,
      privileges: [
        'MODIFY_UNSPSC_FAMILY',
      ]},
    component: () => import("../views/configurations/unspsc-families-bulk-upload.vue"),
  },

  // UNSPSC Class Routes
  {
    path: "/configurations/unspsc-classes",
    name: "commodity-classes",
    meta: {
      title: "Commodity Classes",
      authRequired: true,
      privileges: [
        'VIEW_UNSPSC_CLASSES',
      ]},
    component: () => import("../views/configurations/unspsc-classes.vue"),
  },
  {
    path: "/configurations/unspsc-class-management",
    name: "unspsc-class-management",
    meta: {
      title: "UNSPSC Classes",
      authRequired: true,
      privileges: [
        'VIEW_UNSPSC_CLASSES',
      ]},
    component: () => import("../views/configurations/unspsc-class-management.vue"),
  },
  {
    path: "/configurations/unspsc-class/new",
    name: "new-commodity-class",
    meta: {
      title: "New Commodity Class",
      authRequired: true,
      privileges: [
        'MODIFY_UNSPSC_CLASSES',
      ]},
    component: () => import("../views/configurations/new-unspsc-class.vue"),
  },
  {
    path: "/configurations/unspsc-class/archive",
    name: "archive-unspsc-class",
    meta: {
      title: "Archive UNSPSC Class",
      authRequired: true,
      privileges: [
        'MODIFY_UNSPSC_CLASSES',
      ]},
    component: () => import("../views/configurations/archive-unspsc-class.vue"),
  },
  {
    path: "/configurations/unspsc-class/import",
    name: "commodity-class-import",
    meta: {
      title: "Commodity Class Import",
      authRequired: true,
      privileges: [
        'MODIFY_UNSPSC_CLASSES',
      ]},
    component: () => import("../views/configurations/unspsc-classes-bulk-upload.vue"),
  },

  // UNSPSC Commodities Routes
  {
    path: "/configurations/unspsc-commodities",
    name: "commodities",
    meta: {
      title: "Commodities",
      authRequired: true,
      privileges: [
        'VIEW_UNSPSC_COMMODITIES',
      ]},
    component: () => import("../views/configurations/unspsc-commodities.vue"),
  },
  {
    path: "/configurations/unspsc-commodity-management",
    name: "unspsc-commodity-management",
    meta: {
      title: "UNSPSC Commodities",
      authRequired: true,
      privileges: [
        'VIEW_UNSPSC_COMMODITIES',
      ]},
    component: () => import("../views/configurations/unspsc-commodity-management.vue"),
  },
  {
    path: "/configurations/unspsc-commodity/new",
    name: "new-commodity",
    meta: {
      title: "New Commodity",
      authRequired: true,
      privileges: [
        'MODIFY_UNSPSC_COMMODITIES',
      ]},
    component: () => import("../views/configurations/new-unspsc-commodity.vue"),
  },
  {
    path: "/configurations/unspsc-commodity/archive",
    name: "archive-unspsc-commodity",
    meta: {
      title: "Archive UNSPSC Commodity",
      authRequired: true,
      privileges: [
        'MODIFY_UNSPSC_COMMODITIES',
      ]},
    component: () => import("../views/configurations/archive-unspsc-commodity.vue"),
  },
  {
    path: "/configurations/unspsc-commodity/import",
    name: "commodity-import",
    meta: {
      title: "Commodity Import",
      authRequired: true,
      privileges: [
        'MODIFY_UNSPSC_COMMODITIES',
      ]},
    component: () => import("../views/configurations/unspsc-commodities-bulk-upload.vue"),
  },
  // Province Routes
  {
    path: "/configurations/location-management",
    name: "location-management",
    meta: {
      title: "Procurement Locations",
      authRequired: true,
      privileges: ['VIEW_PROVINCES'],
    },
    component: () => import("../views/configurations/location-management.vue"),
  },
  {
    path: "/configurations/province-management",
    name: "province-management",
    meta: {
      title: "Provinces",
      authRequired: true,
      privileges: [
        'VIEW_PROVINCES',
      ]},
    component: () => import("../views/configurations/province-management.vue"),
  },
  {
    path: "/configurations/provinces/new",
    name: "new-province",
    meta: {
      title: "New Province",
      authRequired: true,
      privileges: [
        'MODIFY_PROVINCES',
      ]},
    component: () => import("../views/configurations/new-province.vue"),
  },
  {
    path: "/configurations/provinces/import",
    name: "provinces-import",
    meta: {
      title: "Provinces Import",
      authRequired: true,
      privileges: [
        'MODIFY_PROVINCES',
      ]},
    component: () => import("../views/configurations/province-bulk-upload.vue"),
  },
  {
    path: "/configurations/provinces/archive",
    name: "archive-province",
    meta: {
      title: "Archive Province",
      authRequired: true,
      privileges: [
        'MODIFY_PROVINCES',
      ]},
    component: () => import("../views/configurations/archive-province.vue"),
  },
  {
    path: "/configurations/provinces/approve",
    name: "approve-province",
    meta: {
      title: "Approve Province",
      authRequired: true,
      privileges: [
        // 'APPROVE_PROVINCES',
      ]},
    component: () => import("../views/configurations/approve-province.vue"),
  },
  {
    path: "/configurations/provinces/archive/approve",
    name: "approve-province-archive",
    meta: {
      title: "Approve Province Archive",
      authRequired: true,
      privileges: [
        // 'APPROVE_PROVINCES',
      ]},
    component: () => import("../views/configurations/approve-province-archive.vue"),
  },
  {
    path: "/configurations/provinces/update/approve",
    name: "approve-province-update",
    meta: {
      title: "Approve Province Update",
      authRequired: true,
      privileges: [
        // 'APPROVE_PROVINCES',
      ]},
    component: () => import("../views/configurations/approve-province-update.vue"),
  },
  // District Routes
  {
    path: "/configurations/districts",
    name: "districts",
    meta: {
      title: "Districts",
      authRequired: true,
      privileges: [
        'VIEW_DISTRICTS',
      ]},
    component: () => import("../views/configurations/districts.vue"),
  },
  {
    path: "/configurations/district-management",
    name: "district-management",
    meta: {
      title: "District Management",
      authRequired: true,
      privileges: [
        'VIEW_DISTRICTS',
      ]},
    component: () => import("../views/configurations/district-management.vue"),
  },
  {
    path: "/configurations/districts/new",
    name: "new-district",
    meta: {
      title: "New District",
      authRequired: true,
      privileges: [
        'MODIFY_DISTRICTS',
      ]},
    component: () => import("../views/configurations/new-district.vue"),
  },
  {
    path: "/configurations/districts/archive",
    name: "archive-district",
    meta: {
      title: "Archive District",
      authRequired: true,
      privileges: [
        'MODIFY_DISTRICTS',
      ]},
    component: () => import("../views/configurations/archive-district.vue"),
  },
  {
    path: "/configurations/districts/approve",
    name: "approve-district",
    meta: {
      title: "Approve District",
      authRequired: true,
      privileges: [
        // 'APPROVE_DISTRICTS',
      ]},
    component: () => import("../views/configurations/approve-district.vue"),
  },
  {
    path: "/configurations/districts/archive/approve",
    name: "approve-district-archive",
    meta: {
      title: "Approve District Archive",
      authRequired: true,
      privileges: [
        // 'APPROVE_DISTRICTS',
      ]},
    component: () => import("../views/configurations/approve-district-archive.vue"),
  },
  {
    path: "/configurations/districts/update/approve",
    name: "approve-district-update",
    meta: {
      title: "Approve District Update",
      authRequired: true,
      privileges: [
        // 'APPROVE_DISTRICTS',
      ]},
    component: () => import("../views/configurations/approve-district-update.vue"),
  },
  {
    path: "/configurations/districts/import",
    name: "districts-import",
    meta: {
      title: "Districts Import",
      authRequired: true,
      privileges: [
        'MODIFY_DISTRICTS',
      ]},
    component: () => import("../views/configurations/district-bulk-upload.vue"),
  },
  // Constituency Routes
  {
    path: "/configurations/constituencies",
    name: "constituencies",
    meta: {
      title: "Constituencies",
      authRequired: true,
      privileges: [
        'VIEW_CONSTITUENCIES',
      ]},
    component: () => import("../views/configurations/constituencies.vue"),
  },
  {
    path: "/configurations/constituency-management",
    name: "constituency-management",
    meta: {
      title: "Constituencies",
      authRequired: true,
      privileges: [
        'VIEW_CONSTITUENCIES',
      ]},
    component: () => import("../views/configurations/constituency-management.vue"),
  },
  {
    path: "/configurations/constituencies/new",
    name: "new-constituency",
    meta: {
      title: "New Constituency",
      authRequired: true,
      privileges: [
        'MODIFY_CONSTITUENCIES',
      ]},
    component: () => import("../views/configurations/new-constituency.vue"),
  },
  {
    path: "/configurations/constituencies/archive",
    name: "archive-constituency",
    meta: {
      title: "Archive Constituency",
      authRequired: true,
      privileges: [
        'MODIFY_CONSTITUENCIES',
      ]},
    component: () => import("../views/configurations/archive-constituency.vue"),
  },
  {
    path: "/configurations/constituencies/import",
    name: "constituencies-import",
    meta: {
      title: "Constituencies Import",
      authRequired: true,
      privileges: [
        'MODIFY_CONSTITUENCIES',
      ]},
    component: () => import("../views/configurations/constituency-bulk-upload.vue"),
  },

  // Ward Routes
  {
    path: "/configurations/ward-management",
    name: "ward-management",
    meta: {
      title: "Wards",
      authRequired: true,
      privileges: [
        'VIEW_WARDS',
      ]},
    component: () => import("../views/configurations/ward-management.vue"),
  },
  {
    path: "/configurations/wards",
    name: "wards",
    meta: {
      title: "Wards",
      authRequired: true,
      privileges: [
        'VIEW_WARDS',
      ]},
    component: () => import("../views/configurations/wards.vue"),
  },
  {
    path: "/configurations/wards/new",
    name: "new-ward",
    meta: {
      title: "New Ward",
      authRequired: true,
      privileges: [
        'MODIFY_WARDS',
      ]},
    component: () => import("../views/configurations/new-ward.vue"),
  },
  {
    path: "/configurations/wards/archive",
    name: "archive-ward",
    meta: {
      title: "Archive Ward",
      authRequired: true,
      privileges: [
        'MODIFY_WARDS',
      ]},
    component: () => import("../views/configurations/archive-ward.vue"),
  },
  {
    path: "/configurations/wards/import",
    name: "wards-import",
    meta: {
      title: "Wards Import",
      authRequired: true,
      privileges: [
        'MODIFY_WARDS',
      ]},
    component: () => import("../views/configurations/ward-bulk-upload.vue"),
  },
  // Office Routes
  {
    path: "/configurations/office-management",
    name: "office-management",
    meta: {
      title: "Offices",
      authRequired: true,
      privileges: [
        'VIEW_OFFICES',
      ]},
    component: () => import("../views/configurations/office-management.vue"),
  },
  {
    path: "/configurations/offices",
    name: "offices",
    meta: {
      title: "Offices",
      authRequired: true,
      privileges: [
        'VIEW_OFFICES',
      ]},
    component: () => import("../views/configurations/offices.vue"),
  },
  {
    path: "/configurations/offices/new",
    name: "new-office",
    meta: {
      title: "New Office",
      authRequired: true,
      privileges: [
        'MODIFY_OFFICES',
      ]},
    component: () => import("../views/configurations/new-office.vue"),
  },
  {
    path: "/configurations/offices/archive",
    name: "archive-office",
    meta: {
      title: "Archive Office",
      authRequired: true,
      privileges: [
        'MODIFY_OFFICES',
      ]},
    component: () => import("../views/configurations/archive-office.vue"),
  },
  {
    path: "/configurations/offices/import",
    name: "offices-import",
    meta: {
      title: "Offices Import",
      authRequired: true,
      privileges: [
        'MODIFY_OFFICES',
      ]},
    component: () => import("../views/configurations/office-bulk-upload.vue"),
  },
  // Department Routes
  {
    path: "/configurations/department-management",
    name: "department-management",
    meta: {
      title: "Departments",
      authRequired: true,
      privileges: [
        'VIEW_DEPARTMENTS',
      ]},
    component: () => import("../views/configurations/departments.vue"),
  },
  {
    path: "/configurations/departments",
    name: "departments",
    meta: {
      title: "Departments",
      authRequired: true,
      privileges: [
        'VIEW_DEPARTMENTS',
      ]},
    component: () => import("../views/configurations/departments.vue"),
  },
  {
    path: "/configurations/departments/new",
    name: "new-department",
    meta: {
      title: "New Department",
      authRequired: true,
      privileges: [
        'MODIFY_DEPARTMENTS',
      ]},
    component: () => import("../views/configurations/new-department.vue"),
  },
  {
    path: "/configurations/departments/archive",
    name: "archive-department",
    meta: {
      title: "Archive Department",
      authRequired: true,
      privileges: [
        'MODIFY_DEPARTMENTS',
      ]},
    component: () => import("../views/configurations/archive-department.vue"),
  },
  {
    path: "/configurations/departments/import",
    name: "departments-import",
    meta: {
      title: "Departments Import",
      authRequired: true,
      privileges: [
        'MODIFY_DEPARTMENTS',
      ]},
    component: () => import("../views/configurations/department-bulk-upload.vue"),
  },
  // Contract Types Routes
  {
    path: "/configurations/contract-types",
    name: "contract-types",
    meta: {
      title: "Contract Types",
      authRequired: true,
      privileges: [
        'VIEW_CONTRACT_TYPES',
      ]},
    component: () => import("../views/configurations/contract-types.vue"),
  },
  {
    path: "/configurations/contract-type-management",
    name: "contract-type-management",
    meta: {
      title: "Contract Types",
      authRequired: true,
      privileges: [
        'VIEW_CONTRACT_TYPES',
      ]},
    component: () => import("../views/configurations/contract-type-management.vue"),
  },
  {
    path: "/configurations/contract-types/new",
    name: "new-contract-type",
    meta: {
      title: "New Contract Type",
      authRequired: true,
      privileges: [
        'MODIFY_CONTRACT_TYPES',
      ]},
    component: () => import("../views/configurations/new-contract-type.vue"),
  },
  {
    path: "/configurations/contract-types/archive",
    name: "archive-contract-type",
    meta: {
      title: "Archive Contract Type",
      authRequired: true,
      privileges: [
        'MODIFY_CONTRACT_TYPES',
      ]},
    component: () => import("../views/configurations/archive-contract-type.vue"),
  },
  {
    path: "/configurations/contract-types/import",
    name: "contract-types-import",
    meta: {
      title: "Contract Types Import",
      authRequired: true,
      privileges: [
        'MODIFY_CONTRACT_TYPES',
      ]},
    component: () => import("../views/configurations/contract-type-bulk-upload.vue"),
  },
  // Funding Sources Routes
  {
    path: "/configurations/funding-source-management",
    name: "funding-source-management",
    meta: {
      title: "Funding Sources",
      moduleKey: "fundingSource",
      authRequired: true,
      privileges: [
        'VIEW_FUNDING_SOURCES',
      ]},
    component: () => import("../views/configurations/lightweight-configuration-management.vue"),
  },
  {
    path: "/configurations/funding-sources",
    name: "funding-sources",
    meta: {
      title: "Funding Sources",
      authRequired: true,
      privileges: [
        'VIEW_FUNDING_SOURCES',
      ]},
    component: () => import("../views/configurations/funding-sources.vue"),
  },
  {
    path: "/configurations/funding-sources/new",
    name: "new-funding-source",
    meta: {
      title: "New Funding Source",
      authRequired: true,
      privileges: [
        'MODIFY_FUNDING_SOURCES',
      ],
      moduleKey: "fundingSource"},
    component: () => import("../views/configurations/lightweight-configuration-form.vue"),
  },
  {
    path: "/configurations/funding-sources/import",
    name: "funding-sources-import",
    meta: {
      title: "Funding Sources Import",
      authRequired: true,
      privileges: [
        'MODIFY_FUNDING_SOURCES',
      ]},
    component: () => import("../views/configurations/funding-source-bulk-upload.vue"),
  },
  // Ledger Codes Routes
  {
    path: "/configurations/ledger-code-management",
    name: "ledger-code-management",
    meta: {
      title: "IFMIS Ledger Codes",
      authRequired: true,
      privileges: [
        'VIEW_IFMIS_LEDGER_CODES',
      ]},
    component: () => import("../views/configurations/ledger-code-management.vue"),
  },
  {
    path: "/configurations/ledger-codes",
    name: "ledger-codes",
    meta: {
      title: "Ledger Codes",
      authRequired: true,
      privileges: [
        'VIEW_IFMIS_LEDGER_CODES',
      ]},
    component: () => import("../views/configurations/ledger-codes.vue"),
  },
  {
    path: "/configurations/ledger-codes/new",
    name: "new-ledger-code",
    meta: {
      title: "New Ledger Code",
      authRequired: true,
      privileges: [
        'MODIFY_IFMIS_LEDGER_CODES',
      ]},
    component: () => import("../views/configurations/new-ledger-code.vue"),
  },
  {
    path: "/configurations/ledger-codes/import",
    name: "ledger-codes-import",
    meta: {
      title: "Ledger Codes Import",
      authRequired: true,
      privileges: [
        'MODIFY_IFMIS_LEDGER_CODES',
      ]},
    component: () => import("../views/configurations/ledger-code-bulk-upload.vue"),
  },
  // Project Code Routes
  {
    path: "/configurations/project-code-management",
    name: "project-code-management",
    meta: {
      title: "Project Codes",
      moduleKey: "projectCode",
      authRequired: true,
      privileges: [
        'VIEW_PROJECT_CODES',
      ]},
    component: () => import("../views/configurations/lightweight-configuration-management.vue"),
  },
  {
    path: "/configurations/project-codes",
    name: "project-codes",
    meta: {
      title: "Project Codes",
      authRequired: true,
      privileges: [
        'VIEW_PROJECT_CODES',
      ]},
    component: () => import("../views/configurations/project-codes.vue"),
  },
  {
    path: "/configurations/project-codes/new",
    name: "new-project-code",
    meta: {
      title: "New Project Code",
      authRequired: true,
      privileges: [
        'MODIFY_PROJECT_CODES',
      ],
      moduleKey: "projectCode"},
    component: () => import("../views/configurations/lightweight-configuration-form.vue"),
  },
  {
    path: "/configurations/project-codes/import",
    name: "project-codes-import",
    meta: {
      title: "Project Codes Import",
      authRequired: true,
      privileges: [
        'VIEW_PROJECT_CODES',
      ]},
    component: () => import("../views/configurations/project-code-bulk-upload.vue"),
  },
  // Unit of Measure Routes
  {
    path: "/configurations/unit-of-measure-management",
    name: "unit-of-measure-management",
    meta: {
      title: "Units of Measure",
      authRequired: true,
      privileges: [
        'VIEW_UNIT_OF_MEASURE',
      ]},
    component: () => import("../views/configurations/unit-of-measure-management.vue"),
  },
  {
    path: "/configurations/units-of-measure",
    name: "units-of-measure",
    meta: {
      title: "Units of Measure",
      authRequired: true,
      privileges: [
        'VIEW_UNIT_OF_MEASURE',
      ]},
    component: () => import("../views/configurations/units-of-measure.vue"),
  },
  {
    path: "/configurations/units-of-measure/new",
    name: "new-unit-of-measure",
    meta: {
      title: "New Units of Measure",
      authRequired: true,
      privileges: [
        'MODIFY_UNIT_OF_MEASURE',
      ]},
    component: () => import("../views/configurations/new-unit-of-measure.vue"),
  },
  {
    path: "/configurations/units-of-measure/import",
    name: "units-of-measure-import",
    meta: {
      title: "Units of Measure Import",
      authRequired: true,
      privileges: [
        'VIEW_UNIT_OF_MEASURE',
      ]},
    component: () => import("../views/configurations/unit-of-measure-bulk-upload.vue"),
  },
  // Reservation Scheme Routes
  {
    path: "/configurations/reservation-scheme-management",
    name: "reservation-scheme-management",
    meta: {
      title: "Reservation Schemes",
      moduleKey: "reservationScheme",
      authRequired: true,
      privileges: [
        'VIEW_RESERVATION_SCHEMES',
      ]},
    component: () => import("../views/configurations/lightweight-configuration-management.vue"),
  },
  {
    path: "/configurations/reservation-schemes",
    name: "reservation-schemes",
    meta: {
      title: "Reservation Schemes",
      authRequired: true,
      privileges: [
        'VIEW_RESERVATION_SCHEMES',
      ]},
    component: () => import("../views/configurations/reservation-schemes.vue"),
  },
  {
    path: "/configurations/reservation-schemes/new",
    name: "new-reservation-scheme",
    meta: {
      title: "New Reservation Scheme",
      authRequired: true,
      privileges: [
        'MODIFY_RESERVATION_SCHEMES',
      ],
      moduleKey: "reservationScheme"},
    component: () => import("../views/configurations/lightweight-configuration-form.vue"),
  },
  {
    path: "/configurations/reservation-schemes/import",
    name: "reservation-schemes-import",
    meta: {
      title: "Reservation Schemes Import",
      authRequired: true,
      privileges: [
        'VIEW_RESERVATION_SCHEMES',
      ]},
    component: () => import("../views/configurations/reservation-scheme-bulk-upload.vue"),
  },

  {
    path: "/configurations/tenders-mandatory-requirements",
    name: "tenders-mandatory-requirements",
    meta: {
      title: "Tenders Mandatory Requirements",
      authRequired: true,
      privileges: [
        'VIEW_UNIT_OF_MEASURE',
      ]},
    component: () => import("../views/configurations/create-mandatory-requirements.vue"),
  },

  {
    path: "/configurations/cip-data",
    name: "cpi-data",
    meta: {
      title: "Consumer Price Index",
      authRequired: true,
      privileges: [
        'VIEW_UNIT_OF_MEASURE',
      ]},
    component: () => import("../views/configurations/cpi-data.vue"),
  },

  {
    path: "/configurations/unspsc-configurations",
    name: "unspsc-configurations",
    meta: {
      title: "UNSPSC Configurations",
      authRequired: true,
      privileges: [
        'MODIFY_UNSPSC_SEGMENT',
      ]},
    component: () => import("../views/configurations/unspscConfig.vue"),
  },

  // Suspension/Barring Reasons Routes
  {
    path: "/configurations/suspension-reason-management",
    name: "suspension-reason-management",
    meta: {
      title: "Suspension/Barring Reasons",
      authRequired: true,
      privileges: []},
    component: () => import("../views/configurations/suspension-reason-management.vue"),
  },
  {
    path: "/configurations/suspension-reasons",
    name: "suspension-reasons",
    meta: {
      title: "Suspension/Barring Reasons",
      authRequired: true,
      privileges: []},
    component: () => import("../views/configurations/suspension-reasons.vue"),
  },
  {
    path: "/configurations/suspension-reasons/new",
    name: "new-suspension-reason",
    meta: {
      title: "New Suspension Reason",
      authRequired: true,
      privileges: []},
    component: () => import("../views/configurations/new-suspension-reason.vue"),
  },
  {
    path: "/configurations/barring-reasons/new",
    name: "new-barring-reason",
    meta: {
      title: "New Barring Reason",
      authRequired: true,
      privileges: []},
    component: () => import("../views/configurations/new-barring-reason.vue"),
  },
];
